import { __assign, __awaiter, __generator } from "tslib";
import { getWdOrigin } from '@office-start/file-utility';
import { logClick } from './logClick';
export function launchAppWacContent(document, context, inlineWacParams, wdOriginType, launchInstrumentationParams, useDeeplinkUrl, additionalParams) {
    if (additionalParams === void 0) { additionalParams = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var startTime, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    startTime = Date.now();
                    if (!(inlineWacParams.shouldHandleWacContent &&
                        context.router.openHostedDocument)) return [3 /*break*/, 2];
                    return [4 /*yield*/, context.router.openHostedDocument(document, startTime, getWdOrigin(context.workload, context.router.getCurrentRoute(), wdOriginType !== null && wdOriginType !== void 0 ? wdOriginType : "OTHER" /* WdOriginType.Other */), inlineWacParams.fluidHostFile, 'DocumentClick', useDeeplinkUrl && document.navId
                            ? __assign({ actinoid: document.navId }, additionalParams) : additionalParams)];
                case 1:
                    success = _a.sent();
                    logClick({
                        launchInstrumentationParams: launchInstrumentationParams,
                        success: success,
                        platform: 'Web',
                    });
                    return [2 /*return*/, {
                            success: success,
                            result: 'Inline',
                            message: 'launchAppWacContent:openHostedDocument',
                        }];
                case 2: return [2 /*return*/, Promise.resolve({
                        success: false,
                        message: 'launchAppWacContent:fallThrough',
                    })];
            }
        });
    });
}
//# sourceMappingURL=launchAppWacContent.js.map